export default "/images/logo.svg?0c8c5f2938116b08bee00df631f2d4c8";